import React from "react";
import DescriptionSkill from "../../descriptionSkill/descriptionSkill";

export default function LanguageSkillDescription({ LanguageSkillData }) {
  return (
   <DescriptionSkill textDesscription={'สามารถใช้'} data={LanguageSkillData} />
  );
}

